import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c12f6a1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-menu" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "   Logout", -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      _createElementVNode("li", null, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.logout()))
        }, _hoisted_3)
      ])
    ])
  ], 512)), [
    [_vShow, _ctx.show]
  ])
}